"use client";

import { createPortal } from "react-dom";
import { cn } from "@/lib/utils";

export default function FloatingTooltipContent({
  id,
  text,
  position,
  visible,
  mounted,
}: {
  id?: string;
  text: string;
  position: { top: number; left: number };
  visible: boolean;
  mounted: boolean;
}) {
  if (!mounted) {
    return null;
  }

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: position.top,
        left: position.left,
        transform: "translate(-50%, -100%)",
      }}
      className="pointer-events-none z-[200]"
    >
      <div
        id={id}
        role="tooltip"
        className={cn(
          "max-w-[220px] rounded-lg border border-line bg-white px-3 py-2 text-xs leading-5 text-foreground shadow-[0_8px_24px_rgb(15_23_42/0.08)] motion-safe:transition-[opacity,transform] motion-safe:duration-150 motion-safe:ease-out",
          visible
            ? "motion-safe:translate-y-0 motion-safe:scale-100 opacity-100"
            : "motion-safe:translate-y-1 motion-safe:scale-[0.98] opacity-0",
        )}
      >
        {text}
      </div>
    </div>,
    document.body,
  );
}
